import { makeStyles } from '@material-ui/core/styles'
import { deepPurple } from '@material-ui/core/colors'

export default makeStyles((theme) => ({
  appBar: {
    borderRadius: 15,
    margin: '30px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 50px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    // backgroundColor: '#E2E2E2',
    

  },
  heading: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontSize: '2em',
    fontWeight: 300,
  },
  image: {
    marginLeft: '10px',
    marginTop: '5px',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '400px',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
  profile: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '400px',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      marginTop: 20,
      justifyContent: 'center',
    },
  },
  logout: {
    marginLeft: '20px',
    // width:'48px'
  },
  userName: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    // color:'maroon',
    // textDecoration: 'underline'

  },
  brandContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
  ourMissionButton: {
    backgroundColor: '#FFA500', // Orange color
    borderRadius: '20px',
    padding: '8px 16px',
   color:'white',
   marginLeft:'20px',
   marginRight:'20px'
  
  },

  ourMissionButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto', // Push the button to the left (center horizontally)

    // justifyContent: 'center',
    // flex: 1,
  },

  signInButton:{

    marginRight:'8px'
  },
}



))
